import { fg } from '@atlassian/jira-feature-gating';

const BoardBulkIssueActionsEnabled = {
	get(): boolean {
		return fg('multi_issue_selection_in_harmonised_board');
	},
};

export default BoardBulkIssueActionsEnabled;
